import CategoryListMobile from './CategoryListMobile.component';

export default CategoryListMobile;
